import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import FloorNewEditForm from './FloorNewEditForm';
// ----------------------------------------------------------------------

export default function FloorCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('Floor.AddTitle')}` : `${translate('Floor.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('Floor.CreateFloor')}`
              : `${translate('Floor.EditFloor')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('Floor.FloorList')}`,
              href: PATH_DASHBOARD.Floor.list,
            },
            {
              name: !isEdit
                ? `${translate('Floor.New')}`
                : `${translate('Floor.Update')}`,
            },
          ]}
        />
        <FloorNewEditForm />
      </Container>
    </Page>
  );
}
